(function(angular, _) {
    'use strict';

    angular.module('GorillaBoy.DocumentViewer')
    .factory('DocumentModalsController', ['$uibModal', '$timeout', 'localStorageService',
        'AppConstants', 'ResourceService', 'SourceConstant', 'DocumentService', 'MessageProvider', 'FileCountService',
        'OrganizationService', 'ClientMetricsService', 'MetricEvents', 'MessageManager', 'SessionManager', 'SignalProvider', DocumentModalsController]);

    function DocumentModalsController($uibModal, $timeout, localStorageService, AppConstants, ResourceService, SourceConstant,
        DocumentService, MessageProvider, FileCountService, OrganizationService, ClientMetricsService, MetricEvents,
        MessageManager, SessionManager, SignalProvider) {
        var TYPE_DOCUMENT = AppConstants.FolderContentTypes.DOCUMENT;
        var viewTypes = AppConstants.ViewTypes;
        var $scope = null;
        var newMethods = {};
        var shareModal, sendMessageModal;
        var removePermissionConfirmModal = null; //TODO: will leak memory, but will fix later
        var deleteDocumentModal = null;
        var CONFIRMATION_TEXT_DELETE = "PURGE";
        var PURGE_PRIOR_VERSIONS_WAIT_TIME = 2000;

        newMethods.showSendMessageModal = function() {
            if ($scope.allowFeedback()) {

                sendMessageModal = $uibModal.open({
                    templateUrl: './share-modal/send_message_dialog.html',
                    controller: 'sendMessageModalCtrl',
                    resolve: {
                        documentId: function() {
                            return $scope.documentState.documentId;
                        },
                        documentState : function() {
                            return $scope.documentState;
                        },
                        scopeUser: function() {
                            return $scope.user;
                        }
                    }
                });

                sendMessageModal.result.then(function() {
                    sendMessageModal = null;
                }, function() {
                    sendMessageModal = null;
                });
            }

            ClientMetricsService.addClickToSession('btn_send_message');
        };

        //################################## -- these two modals work together, one shows a confirmation modal, the other does the action
        newMethods.deleteDocument = function() {
            if (deleteDocumentModal) {
                deleteDocumentModal.close();
            }

            DocumentService.recycleDocument($scope.metadata.Id)
            .success(function() {
                FileCountService.signal();
                SessionManager.setDeletedItems([$scope.metadata.Id], []);

                $scope.showFolder($scope.metadata.ParentFolderId);

                $timeout(function() {
                    MessageManager.addSuccessMessage(MessageProvider.documentDeleteSuccess);
                }, 0);
            })
            .error(function(data, status, headers, config) {
                if (data.Message.indexOf('EntityNotExistsException') >= 0) {
                    MessageManager.addErrorMessage(MessageProvider.folderDocumentDeleteNotExists);
                } else {
                    MessageManager.addErrorMessage(MessageProvider.folderDocumentDeleteFailDefault($scope.metadata.VersionMetadata.Name));
                }
            });
        };
        newMethods.showDocumentDeleteModal = function() {
            deleteDocumentModal = $uibModal.open({
                templateUrl: 'deleteDocumentModal.html',
            });
            deleteDocumentModal.result.then(function() {
                $scope.deleteDocument();
            }).finally(function() {
                deleteDocumentModal = null;
            });

            // Remove instance on destroy to prevent memory leak
            $scope.$on("$destroy", function() {
                if (deleteDocumentModal) {
                    deleteDocumentModal.close();
                }
            });
        };

        //###############################################################
        //DELETING A SINGLE DOCUMENT VERSION

        newMethods.showPurgeVersionModal = function() {
            var templateUrl = './document-viewer/purge_document_version_modal.html'
            $scope.modals.purgeVersionConfirmationText = "";

            if ($scope.isVersionDeleteEnabled) {
                templateUrl = './document-viewer/version_delete_modal.html';
                $scope.modals.purgeVersionId = $scope.documentState.activeVersion.VersionId;
            }
            var purgeVersionModal = $uibModal.open({
                templateUrl: templateUrl,
                controller: 'PurgeDocumentVersionController',
                scope: $scope
            });

            purgeVersionModal.result.then(function() {
                purgeVersionModal = null;
            }, function() {
                purgeVersionModal = null;
            });
            $scope.$on("$destroy", function() {
                if (purgeVersionModal) {
                    purgeVersionModal.close();
                }
            });
        };

        //#####################################################
        //DELETING MULTIPLE DOCUMENT VERSIONS

        newMethods.showPurgePriorVersionsModal = function() {
             $scope.modals.purgeVersionConfirmationText = "";
             var purgePriorVersionsModal = $uibModal.open({
                 templateUrl: './document-viewer/purge_prior_document_versions_modal.html',
                 controller: 'PurgeDocumentVersionController',
                 scope: $scope
             });

             purgePriorVersionsModal.result.then(function() {
                 purgePriorVersionsModal = null;
             }, function() {
                 purgePriorVersionsModal = null;
             });
             $scope.$on("$destroy", function() {
                  if (purgePriorVersionsModal) {
                      purgePriorVersionsModal.close();
                  }
             });
         };

        newMethods.isOrgWideLinkSharingEnabled = function() {
            return AppConstants.ORG_WIDE_SHARING_SCOPE !== 'NONE';
        }
        
        newMethods.showCreateShareLinkModal = function() {
            ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
            ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);

            shareModal = $uibModal.open({
                templateUrl: './share-modal/share_link_modal_dialog.html',
                controller: 'gbShareLinkModalCtrl',
                size: 'sl',
                resolve: {
                    inFolderView: function() {
                        return false;
                    },
                    isFolder: function() {
                        return false;
                    },
                    pendingShareType: function() {
                        return TYPE_DOCUMENT;
                    },
                    shareResourceId: function() {
                        return $scope.documentState.documentId;
                    },
                    shareResourceName: function() {
                        return $scope.documentState.activeVersion.Name;
                    },
                    isAnonymous: function() {
                        return $scope.layout.isAnonymous;
                    },
                    currentOwnerOrganizationId: function() {
                        return $scope.user.OrganizationId;
                    },
                    currentOwnerUsername: function() {
                        return $scope.documentState.currentOwnerUsername;
                    }
                }
            });

            shareModal.result.then(function(response) {
                shareModal = null;
                $scope.metadata.SharedAnonymously = response.isAnyoneLink;
                $scope.metadata.SharedWithOrganization = response.isSiteLink;
            }, function() {
                shareModal = null;
            });

        };

        newMethods.showCreateShareModal = function() {
            ClientMetricsService.startLatencyEvent(MetricEvents.NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
            ClientMetricsService.startLatencyEvent(MetricEvents.NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);

            shareModal = $uibModal.open({
                templateUrl: './share-modal/share_modal_dialog.html',
                controller: 'gbShareModalCtrl',
                size: 'lg',
                resolve: {
                    inFolderView: function() {
                        return false;
                    },
                    isFolder: function() {
                        return false;
                    },
                    pendingShareType: function() {
                        return TYPE_DOCUMENT;
                    },
                    shareResourceId: function() {
                        return $scope.documentState.documentId;
                    },
                    shareResourceName: function() {
                        return $scope.documentState.activeVersion.Name;
                    },
                    isAnonymous: function() {
                        return $scope.layout.isAnonymous;
                    },
                    currentOwnerInfo: function() {
                        return $scope.user;
                    },
                    currentOwnerUsername: function() {
                        return $scope.documentState.currentOwnerUsername;
                    },
                    shareOnly: function() {
                        return null;
                    },
                    CommentsLocked : function() {
                        return $scope.metadata.CommentsLocked;
                    }
                }
            });

            shareModal.result.then(function(response) {
                if (response && response.isOpenShareLinkModal) {
                    $scope.showCreateShareLinkModal();
                } else {
                    $scope.getDocument();
                    $scope.$broadcast(SignalProvider.Sidebar.HideAnnotationArrow);
                }
                shareModal = null;

            }, function() {
                shareModal = null;
            });

            ClientMetricsService.addClickToSession('btn_share');

        };

        return {
            initScope : function($scopeVal) {
                $scope = $scopeVal;
                $scope.$on("$destroy", function() {
                    $scope = null;
                });
                // This event is fired inside share_link_modal_dialog
                $scope.$on(SignalProvider.ShareLink.Created, function(event, param){

                    var sharedWithOrg = false, sharedAnon = false;
                     switch(param.linkScope){
                          case 'ANYONE':
                              sharedAnon = true;
                              break;
                          case 'SITE_VIEWER':
                          case 'SITE_CONTRIBUTOR':
                              sharedWithOrg = true;
                              break;
                     }

                     $scope.metadata.SharedAnonymously = sharedAnon;
                     $scope.metadata.SharedWithOrganization = sharedWithOrg;
                });
                $scope.modals = {
                    principalId: null,
                    principalName: null,
                };
                angular.extend($scope, newMethods);
            }
        };
    }

}(angular, _));
